import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {Constants} from '../../common/constants';
import {Group} from '../../model/group';
import {environment} from '../../environments/environment';
import {Set} from '../../model/set';
import {MasbitHttpService} from '../../common/http/masbit-http.service';

@Injectable()
export class GroupsService {

  private static readonly DELETE_GROUP_SERVICE_URL = environment.apiUrl.concat(environment.deleteGroupsServiceUrl);
  private static readonly BLOCK_UNBLOCK_GROUP_SERVICE_URL = environment.apiUrl.concat(environment.blockUnblockServiceUrl);
  private static readonly GET_GROUP_SERVICE_URL = environment.apiUrl.concat(environment.getGroupServiceUrl);
  private static readonly REMOVE_USER_FROM_GROUP_SERVICE_URL = environment.apiUrl.concat(environment.removeUserFromGroupServiceUrl);
  private static readonly GET_UNIQUE_DOMAIN_NAMES_SERVICE_URL = environment.apiUrl.concat(environment.getDomainNames);
  private static readonly GET_DOMAIN_IDS_BY_NAMES_SERVICE_URL = environment.apiUrl.concat(environment.getDomainsIdsByName);
  private static readonly GET_SETS_BY_ID_SERVICE_URL = environment.apiUrl.concat(environment.getSetServiceUrl);
  private static readonly UPDATE_SAFEDOMAIN_SERVICE_URL = environment.apiUrl.concat(environment.updateDomainServiceUrl );
  private static readonly UPDATE_GROUP_SERVICE_URL = environment.apiUrl.concat(environment.updateGroupServiceUrl);
  private static readonly GROUP_EXISTS_SERVICE_URL = environment.apiUrl.concat(environment.groupExistsServiceUrl);

  constructor(private httpClient : MasbitHttpService) { }

  deleteGroups(groupsToRemove: Array<number>) : Observable<BackendServiceResponse<number, Array<Group>>> {
    const body = {
      groupIds : groupsToRemove
    };
    return this.httpClient.deleteWithBody<BackendServiceResponse<number, Array<Group>>>(GroupsService.DELETE_GROUP_SERVICE_URL, body);
  }

  unBlockGroup(groupId : number) : Observable<BackendServiceResponse<number, string>> {
    let data: any;
    data = {id: groupId, blocked: false};
    return this.httpClient.put<BackendServiceResponse<number, string>>(GroupsService.BLOCK_UNBLOCK_GROUP_SERVICE_URL, data);
  }

  blockGroup(groupId : number, blockedTill: any) : Observable<BackendServiceResponse<number, string>> {
    let dataToSend: any;
    dataToSend = {
      id : groupId,
      blocked : true,
      blockedTill : blockedTill
    };
    return this.httpClient.put<BackendServiceResponse<number, string>>(GroupsService.BLOCK_UNBLOCK_GROUP_SERVICE_URL, dataToSend);
  }

  getGroup(groupId : number) : Observable<BackendServiceResponse<number, Array<Group>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<Group>>>(GroupsService.GET_GROUP_SERVICE_URL,{id : groupId})
  }

  removeUserFromGroup(groupId : number, userIds: Array<number>) : Observable<BackendServiceResponse<number, string>> {
    let dataToSend = {
      id : groupId,
      userIds : userIds
    };

    return this.httpClient.post<BackendServiceResponse<number, string>>(GroupsService.REMOVE_USER_FROM_GROUP_SERVICE_URL, dataToSend);
  }

  getSetList(): Observable<BackendServiceResponse<number,Array<Set>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<Set>>>(Constants.GET_SETS_URL);
  }

  getDomainsForFilter() : Observable<BackendServiceResponse<number, Array<string>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<string>>>(GroupsService.GET_UNIQUE_DOMAIN_NAMES_SERVICE_URL);
  }

  getDomainIdsByDomainNames(domainsNames : Array<string>) : Observable<BackendServiceResponse<number, Array<string>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<string>>>(GroupsService.GET_DOMAIN_IDS_BY_NAMES_SERVICE_URL, {names : domainsNames});
  }

  getFilteredGroupList(groupData : any) : Observable<BackendServiceResponse<string, Array<Group>>> {
    return this.httpClient.post<BackendServiceResponse<string, Array<Group>>>(Constants.GET_GROUPS_URL, groupData);
  }
}
